<template>
    <v-container fluid class="ma-0 pa-0">
        <v-layout fill-height>
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 1920 495" preserveAspectRatio="none">
                <defs>
                    <linearGradient id="b" x1=".341" y1="-.067" x2=".473" y2="1.899" gradientUnits="objectBoundingBox">
                        <stop offset="0" :stop-color="stopColor1" />
                        <stop offset=".916" :stop-color="stopColor2" />
                        <stop offset="1" :stop-color="stopColor3" />
                    </linearGradient>
                    <clipPath id="a">
                        <path transform="translate(0 585)" fill="#0eccf2" d="M0 0h1920v495H0z" />
                    </clipPath>
                </defs>
                <g transform="translate(0 -585)" clip-path="url(#a)">
                    <path transform="translate(0 585)" fill="url(#b)" d="M0 0h1920v495H0z" />
                    <circle cx="618" cy="618" r="618" transform="translate(342 644)" :fill="circleColor1" />
                    <circle cx="641.5" cy="641.5" r="641.5" transform="translate(-541 540)" :fill="circleColor2" />
                </g>
            </svg>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'forgotPasswordSVG',
        props: {
            rectColor: {
                type: String,
                required: true
            },
            stopColor1: {
                type: String,
                required: true
            },
            stopColor2: {
                type: String,
                required: true
            },
            stopColor3: {
                type: String,
                required: true
            },
            circleColor1: {
                type: String,
                required: true
            },
            circleColor2: {
                type: String,
                required: true
            },
        },
    }
</script>

<style scoped>
    .my-svg-component {
        /* Scoped CSS here */
    }
</style>